import React from 'react';
import MainPanel from './MainPanel';
import { MetronomeProvider } from '../contexts/MetronomeContext';

const MetronomeApp = () => {
  return (
    <MetronomeProvider>
      <div className="flex flex-col">
        <main className="container mx-auto px-4 pb-8">
          <MainPanel />
        </main>
      </div>
    </MetronomeProvider>
  );
};

export default MetronomeApp;